<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col" v-if="project.picture">
            <img class="img-fluid img-card mt-2" :src="project.picture" alt="">
          </div>
        </div>
        <div class="row py-4 justify-content-center" v-if="featuredLinks">
          <a
            v-for="link in featuredLinks"
            :key="link.id"
            class="btn col-md-4 col-10 m-2 d-flex justify-content-center align-items-center"
            :class="link.kind === 'primary' ? 'btn-primary' : link.kind === 'secondary' ? 'btn-outline-primary' : 'btn-outline-default'"
            :href="link.url"
          >
              {{ link.title }}
          </a>
        </div>
        <p v-if="project.about" v-html="project.about" class="pre lh15"></p>
        <div class="row py-4 justify-content-center" v-if="extraLinks">
          <a
            v-for="link in extraLinks"
            :key="link.id"
            class="btn small col-md-4 col-5 m-2 d-flex justify-content-center align-items-center"
            :class="link.kind === 'primary' ? 'btn-primary' : link.kind === 'secondary' ? 'btn-outline-primary' : 'btn-outline-default'"
            :href="link.url"
          >
              {{ link.title }}
          </a>
        </div>
      </div>
    </div>

    <hr class="hr-separator">

    <hr class="space space-xs">

    <div class="row" v-if="project">
      <div class="col-md-8">
        <div>
          <p class="regular large muted pb-2">
            <img src="/static/images/icons/timeline.svg" alt="">
            Timeline
          </p>
        </div>
        <div
          v-for="(post, index) in posts"
          :key="post.id"
          class="pb-4 mb-4"
        >
          <p class="regular large mb-0">
            <img v-if="index === 0" alt="" src="/static/images/icons/dot.svg">
            <img v-else src="/static/images/icons/dot_inactive.svg">
            {{ post.title }}
          </p>
          <p class="small muted pl-4 mb-1">
            {{ post.published | moment("D MMMM YYYY") }}
          </p>
          <p class="pl-4 small">
            {{ post.body }}
          </p>
          <p class="pl-4" v-if="post.cta_title && post.cta_link">
            <a
              :href="post.cta_link"
              class="btn btn-sm btn-outline-default"
            >
              {{ post.cta_title }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'project-overview',
  props: ['id'],
  data () {
    return {
      onboardingComplete: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      project: state => state.projects.current
    }),
    featuredLinks () {
      if (this.project && this.project.links) {
        return this.project.links.filter(e => e.is_featured)
      }
      return []
    },
    extraLinks () {
      if (this.project && this.project.links) {
        return this.project.links.filter(e => !e.is_featured)
      }
      return []
    },
    posts () {
      if (this.project && this.project.posts) {
        return this.project.posts
      }
      return []
    }
  },
  mounted () {
    if (!this.project || !this.project.id === this.id) {
      this.$store.dispatch('LOAD_PROJECT_BY_ID', this.id)
    }
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
